export default __webpack_public_path__ + "static/media/escrow_background_leaf.b4a2732c.svg";